module.exports = __webpack_public_path__ + "img/mono-cat.3dc35563.jpg";